import { styled } from "@mui/material";
import { types } from "api";
import { InfoSnackBar } from "components/InfoSnackBar";
import { DELETE_FAIL } from "messages";
import { useState } from "react";
import { getPath as getRoutePath, routes } from "routes";
import { GroupListItem } from "./GroupListItem";

const PREFIX = "GroupList";

const classes = {
	root: `${PREFIX}-root`,
};

const Root = styled("div")(() => ({
	[`&.${classes.root}`]: {
		width: "100%",
	},
}));

export interface GroupListProps {
	groups: types.Group[];
	getPath?: (groupId: string) => string;
}

const defaultGetPath = (groupId: string): string =>
	getRoutePath(routes._.groups._.view, { groupId });

export const GroupList = ({
	groups,
	getPath = defaultGetPath,
}: GroupListProps): JSX.Element => {
	const [err, setErr] = useState<boolean>(false);

	return (
		<Root className={classes.root}>
			{groups.map((row, index) => {
				const labelId = `assignment-${index}`;

				return (
					<GroupListItem
						group={row}
						labelId={labelId}
						key={row.name}
						getPath={getPath}
					/>
				);
			})}
			<InfoSnackBar
				isOpen={err}
				onClose={() => setErr(false)}
				message={DELETE_FAIL}
				severity="error"
			/>
		</Root>
	);
};
